/* eslint-disable no-unused-vars */
import { api } from '@/helpers/api';

export default {
  async getStudents({ commit }, payload) {
    const response = await api.get('parent/me/students', { params: payload });
    commit('setStudents', response.data.results);
  },

  async getProfile({ commit }, payload) {
    const response = await api.get('parent/me/profile', { params: payload });
    const { parent } = response.data.results;
    const { onboardingMobile, onboardingDesktop } = parent || {};


    const commitOnboardingMutations = (deviceType, onboardingData) => {
      if (onboardingData) {
        Object.entries(onboardingData).forEach(([property, value]) => {
          commit(`onboarding/setOnboarding${deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}${property.charAt(0).toUpperCase() + property.slice(1)}`, value, { root: true });
        });
      }
    };

    commitOnboardingMutations('Mobile', onboardingMobile);
    commitOnboardingMutations('Desktop', onboardingDesktop);

    commit('setStudents', parent.students);
  },

  async updateStudent({ commit }, payload) {
    const response = await api.get(`parent/me/students/${payload}`);
    const data = response.data.results;
    const { onboardingMobile, onboardingDesktop } = data || {};

    const commitOnboardingMutations = (deviceType, onboardingData) => {
      if (onboardingData) {
        Object.entries(onboardingData).forEach(([property, value]) => {
          commit(`onboarding/setOnboarding${deviceType.charAt(0).toUpperCase() + deviceType.slice(1)}${property.charAt(0).toUpperCase() + property.slice(1)}`, value, { root: true });
        });
      }
    };

    commitOnboardingMutations('Mobile', onboardingMobile);
    commitOnboardingMutations('Desktop', onboardingDesktop);
    commit('auth/setAccess', data.access, { root: true });
    commit('setStudent', data);
  },

  async getStudentAgreementFile({ commit }, payload) {
    const respone = await api.get(`parent/me/agreement/${payload}`, { responseType: 'blob' });

    return respone.data;
  },

  clearStudent({ commit }) {
    commit('clearStudent');
  },

  clearStudents({ commit }) {
    commit('clearStudents');
  },
};
